var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import ErrorModal from "./error/Modal";
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            errorInfo: null,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            errorInfo: errorInfo,
        });
        // You can also log error messages to an error reporting service here
        if (window.Raven) {
            window.Raven.captureException(error);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var _this = this;
        var errorInfo = this.state.errorInfo;
        var children = this.props.children;
        var handleErrorClose = function () { return _this.setState({ errorInfo: null }); };
        if (errorInfo) {
            // Render fallback UI
            return (React.createElement(ErrorModal, { error: "Error Occurred on Render", handleErrorClose: handleErrorClose }));
        }
        return children;
    };
    return ErrorBoundary;
}(Component));
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map